import { isLoading, Loading } from "../loading";
import { redirect } from "../util";
import { useAllTaskTypes } from "./useTaskTypes";
import { Task } from "../types/Task";

export const useAfterComplete = (
  task: Record<string, unknown> | undefined | Loading
): (() => void) => {
  const { data: taskTypes, isLoading: isTaskTypesLoading } = useAllTaskTypes();

  const afterComplete = taskTypes?.find(
    (type) => type.id === (task as Task)?.task_type_id
  )?.after_complete;

  if (
    isLoading(task) ||
    isTaskTypesLoading ||
    !afterComplete ||
    task === undefined
  ) {
    return () => {};
  }

  const executeAfterComplete = () => {
    const { id, props } = afterComplete;

    switch (id) {
      case "redirect": {
        const { url, openNewTab } = props;

        redirect(url, openNewTab);
        return;
      }
      default:
        return;
    }
  };

  return executeAfterComplete;
};
